import React from 'react';
import { motion } from 'framer-motion';
import { LockIcon, ShieldCheckIcon, StarIcon } from 'lucide-react';
export function HeroSection() {
  const scrollToFinalCTA = () => {
    document.getElementById('final-cta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-20 pb-12 md:pt-36 md:pb-24 px-3 md:px-4 overflow-hidden bg-dark" data-id="element-127">
      {/* Background image */}
      <div className="absolute inset-0" data-id="element-128">
        <img src="https://cdn.magicpatterns.com/uploads/cpPbvDp775FcG8YtzpzS6B/BBQ1.png" alt="" className="w-full h-full object-cover" data-id="element-129" />
        <div className="absolute inset-0 bg-gradient-to-b from-dark/90 via-dark/85 to-dark" data-id="element-130"></div>
      </div>
      {/* Subtle amber glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] bg-amber/8 rounded-full blur-[150px] pointer-events-none" data-id="element-131"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-132">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-133">
          <p className="text-amber font-heading uppercase tracking-[0.25em] text-sm md:text-base mb-5 font-semibold" data-id="element-134">
            The 2026 Heat-Flow System
          </p>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="font-heading text-3xl sm:text-5xl md:text-6xl lg:text-7xl font-black text-white leading-[0.95] mb-4 md:mb-6 uppercase tracking-tighter" data-id="element-135">
          How to Master Texas-Quality BBQ on the $99 Grill{' '}
          <span className="text-[#E69D4F]" data-id="element-136">You Already Own</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="text-base sm:text-xl md:text-2xl italic mb-3 md:mb-5 max-w-3xl mx-auto" data-id="element-137">
          <span className="text-[#EF7D43]" data-id="element-138">
            — Even If You've Ruined Every Brisket You've Ever Touched.
          </span>
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-base md:text-xl text-smoke tracking-wide mb-8 md:mb-14 max-w-3xl mx-auto leading-relaxed" data-id="element-139">
          Stop guessing. Stop wasting $120 on dry meat. Discover the system that
          turns any backyard amateur into the neighborhood's undisputed
          Pitmaster in 30 days or less.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="flex flex-col items-center" data-id="element-140">
          <img src="https://cdn.magicpatterns.com/uploads/8zvtzHu22Z4VsxFqvYvVH8/HERO_BBQ.png" alt="Perfect smoked brisket on a cutting board" className="w-full max-w-md mx-auto rounded-2xl mb-6 shadow-2xl" data-id="element-141" />

          <button onClick={scrollToFinalCTA} className="w-full sm:w-auto bg-gradient-to-r from-[#F2B851] to-[#C45F2A] border-b-4 border-[#964215] rounded-md text-[#0F1111] font-black uppercase text-sm sm:text-base md:text-xl py-4 md:py-5 px-4 sm:px-6 md:px-14 shadow-[0_0_25px_rgba(242,184,81,0.4)] hover:brightness-110 hover:-translate-y-0.5 active:translate-y-0.5 active:border-b-2 transition-all duration-200" data-id="element-142">
            🔥 YES — MASTER THE SMOKE FOR $6.99 →
          </button>

          <div className="flex items-center gap-2 mt-6 text-smoke text-sm" data-id="element-143">
            <LockIcon size={14} data-id="element-144" />
            <span data-id="element-145">Secure checkout</span>
            <span className="mx-1" data-id="element-146">·</span>
            <ShieldCheckIcon size={14} data-id="element-147" />
            <span data-id="element-148">14-day guarantee</span>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-1 sm:gap-2 mt-3 md:mt-4" data-id="element-149">
            <div className="flex gap-0.5" data-id="element-150">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-3.5 h-3.5 md:w-4 md:h-4 fill-[#FFC107] text-[#FFC107]" data-id="element-151" />)}
            </div>
            <span className="text-smoke text-xs md:text-sm" data-id="element-152">
              <span className="font-bold text-ivory" data-id="element-153">4,812 pitmasters</span>{' '}
              already mastered the flame
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}